import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ConfirmModal, EmailModal } from 'src/modules/shared';
import {
	AwardLotModal,
	SelectionMethodModal
} from 'src/modules/features/admin/modals';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
@Component({
	selector: 'app-identification',
	templateUrl: './identification.component.html',
	styleUrls: [ './identification.component.scss' ]
})
export class IdentificationComponent implements OnInit {
	project;
	projectId: string;
	projectFields;
	success: any;
	error: any;
	pending: boolean;

	constructor(
		private modalService: SuiModalService,
		private location: Location,
		private activatedRoute: ActivatedRoute
	) {
		this.activatedRoute.parent.params.subscribe((params) => {
			this.projectId = params['id'];
		});
	}
	enterNumber() {
		this.modalService
			.open(new EmailModal('Enter Number', 'Are you sure you want to delete this Lot plan?', ModalSize.Tiny))
			.onApprove(() => {})
			.onDeny(() => {});
	}

	edit() {
		this.modalService
			.open(
				new AwardLotModal(
					'Update Appropriation',
					'Are you sure you want to delete this Lot plan?',
					ModalSize.Tiny
				)
			)
			.onApprove(() => {})
			.onDeny(() => {});
	}
	updateAppropriation() {
		// this.modalService
		// 	.open(
		// 		new AppropriationModal(
		// 			'Update Appropriation',
		// 			'Are you sure you want to delete this Lot plan?',
		// 			ModalSize.Tiny
		// 		)
		// 	)
		// 	.onApprove(() => {})
		// 	.onDeny(() => {});
	}

	updateProcurement() {
		// this.modalService
		// 	.open(
		// 		new ProcurementTypeModal(
		// 			'Update Procurement Type',
		// 			'Are you sure you want to delete this Lot plan?',
		// 			ModalSize.Tiny
		// 		)
		// 	)
		// 	.onApprove(() => {})
		// 	.onDeny(() => {});
	}

	updateSelection() {
		this.modalService
			.open(
				new SelectionMethodModal(
					'Update Selection Method',
					'Are you sure you want to delete this Lot plan?',
					ModalSize.Tiny
				)
			)
			.onApprove(() => {})
			.onDeny(() => {});
	}
	deleteLot() {
		this.modalService
			.open(new ConfirmModal('Delete Award?', 'Are you sure you want to delete selected Award?', ModalSize.Tiny))
			.onApprove(() => {})
			.onDeny(() => {});
	}
	goBack() {
		this.location.back();
	}

	ngOnInit(): void {}
}
